/* eslint-disable no-nested-ternary */
/* eslint-disable @typescript-eslint/no-non-null-assertion */
/* eslint-disable react/destructuring-assignment */
import { Group, Space } from '@mantine/core';
import { Table } from 'antd';
import { ColumnsType } from 'antd/lib/table';
import PageSection from '../../../../../../components/core/PageSection/PageSection';
import ProfileCardLink from '../../../../../../components/core/ProfileCardLink/ProfileCardLink';
import TableCellEllipsis from '../../../../../../components/core/TableCellEllipsis/TableCellEllipsis';
import { EntityEquipmentType } from '../../../../../../models/core/entities.type';
import { Feature } from '../../../../../../utils/constants.utils';
import { formatTimestampToString } from '../../../../../../utils/formatter.utils';

type ViewProps = {
  data: EntityEquipmentType[];
};

export default function EquipmentView(props: ViewProps) {
  const columns: ColumnsType<any> = [
    {
      title: 'Equipamento',
      key: 'residuoEquipamento',
      dataIndex: 'residuoEquipamento',
      sorter: (a: EntityEquipmentType, b: EntityEquipmentType) =>
        a.residuoEquipamento.localeCompare(b.residuoEquipamento),
    },
    {
      title: 'Descrição',
      key: 'residuoEquipamentoDescricao',
      sorter: (a: EntityEquipmentType, b: EntityEquipmentType) =>
        (a.residuoEquipamentoDescricao || '').localeCompare(b.residuoEquipamentoDescricao || ''),
      render: (row: EntityEquipmentType) => (
        <TableCellEllipsis label={row?.residuoEquipamentoDescricao} numberOfChars={25} toolTipWidth={300} />
      ),
    },
    {
      title: 'Tipo',
      key: 'proprio',
      sorter: (a: EntityEquipmentType, b: EntityEquipmentType) =>
        a.proprio === b.proprio ? 0 : a.proprio ? -1 : 1,
      render: (row: EntityEquipmentType) => <div>{row?.proprio ? 'Próprio' : 'Terceirizado'}</div>,
    },
    {
      title: 'Criado Por',
      key: 'criadoPor',
      sorter: (a: EntityEquipmentType, b: EntityEquipmentType) => a.criadoPor.localeCompare(b.criadoPor),
      render: (row: EntityEquipmentType) => (
        <ProfileCardLink id={row.idCriadoPor} name={row.criadoPor} nameSize="sm" />
      ),
    },
    {
      title: 'Data Criação',
      key: 'dataCriacao',
      sorter: (a: EntityEquipmentType, b: EntityEquipmentType) => {
        const aValue = a.dataCriacao.valueOf();
        const bValue = b.dataCriacao.valueOf();
        if (aValue === bValue) {
          return 0;
        }
        return aValue > bValue ? 1 : -1;
      },
      render: (row: EntityEquipmentType) => formatTimestampToString(row.dataCriacao),
    },
    {
      title: 'Modificado Por',
      key: 'modificadoPor',
      sorter: (a: EntityEquipmentType, b: EntityEquipmentType) =>
        (a.modificadoPor || '').localeCompare(b.modificadoPor || ''),
      render: (row: EntityEquipmentType) => {
        if (row.idModificadoPor) {
          return (
            <ProfileCardLink id={row.idModificadoPor || ''} name={row.modificadoPor || ''} nameSize="sm" />
          );
        }
        return '-';
      },
    },
    {
      title: 'Data Modificação',
      key: 'dataModificacao',
      sorter: (a: EntityEquipmentType, b: EntityEquipmentType) => {
        const date = new Date();
        return new Date(a.dataModificacao || date).valueOf() - new Date(b.dataModificacao || date).valueOf();
      },
      render: (row: EntityEquipmentType) => {
        if (row.dataModificacao) {
          return formatTimestampToString(row.dataModificacao);
        }
        return '-';
      },
    },
  ];

  return (
    <div>
      <Group>
        <PageSection size="lg" color={Feature.Reference.Entity.color} label="Equipamentos" text="" />
      </Group>
      <Space h="xs" />
      <Table
        showSorterTooltip={false}
        // size="small"
        dataSource={props.data}
        columns={columns}
        rowKey={(item: EntityEquipmentType) => item.idEntidadeResiduoEquipamento || 0}
        pagination={{
          pageSizeOptions: [10, 25, 50],
          showSizeChanger: true,
          showTotal: (total, range) => `${range[0]} - ${range[1]} de ${total} resultado(s)`,
        }}
      />
    </div>
  );
}
